import n from "react";
const a = _ref => {
  let {
    adUrl: e,
    adUrlTarget: r,
    onClick: l,
    onAuxClick: t,
    titleID: i
  } = _ref;
  return n.createElement("a", {
    "data-ds-component": "DS-NewAdCard-Link",
    href: e,
    target: r,
    onClick: l,
    onAuxClick: t,
    "aria-labelledby": i,
    className: "olx-ad-card__link-wrapper"
  });
};
a.displayName = "LinkWrapper";
export { a as LinkWrapper };